<script lang="ts">
  import LegalLayout from "./LegalLayout.svelte";
</script>

<LegalLayout title="Refund Policy" effective="27 May 2026">
  <p>
    This Refund Policy explains when and how you can obtain a refund for an Optio subscription. It
    forms part of our <a href="/terms">Terms of Service</a>.
  </p>

  <h2>1. Subscriptions</h2>
  <p>
    Optio paid plans are billed in advance on a recurring basis (monthly or yearly) and renew
    automatically until cancelled. Your plan and renewal date are shown on your
    <a href="/account/billing">account billing</a> page.
  </p>

  <h2>2. Cancellation</h2>
  <p>
    You may cancel at any time. Cancelling stops future renewals; you keep access to your paid
    features until the end of the current billing period. We do not automatically pro-rate or refund
    the unused portion of a period unless required by law or stated below.
  </p>

  <h2>3. Refund eligibility</h2>
  <ul>
    <li>
      <strong>14-day refund</strong> — if you are not satisfied, you may request a full refund within
      14 days of your initial purchase or of a renewal charge.
    </li>
    <li>
      <strong>Billing errors</strong> — if you were charged in error or charged more than once, we will
      refund the incorrect amount.
    </li>
    <li>
      <strong>Service failure</strong> — if a paid feature is unavailable for an extended period due to
      a fault on our side, contact us and we will make it right.
    </li>
  </ul>
  <p>
    Refunds are generally not available for periods that have already been substantially used beyond
    the windows above, except where required by applicable law.
  </p>

  <h2>4. How to request a refund</h2>
  <p>
    Email <a href="mailto:info@optioway.com">info@optioway.com</a> with the email address on your
    account and your order or transaction reference. Because
    <a href="https://www.paddle.com" target="_blank" rel="noopener noreferrer">Paddle.com</a> is our Merchant
    of Record, refunds are issued by Paddle to your original payment method. You can also request help
    directly through the receipt Paddle emailed you.
  </p>

  <h2>5. Processing time</h2>
  <p>
    Approved refunds are processed promptly. The time for the funds to appear depends on your bank
    or card provider, typically within 5–10 business days.
  </p>

  <h2>6. Contact</h2>
  <p>
    Questions about refunds or cancellations can be sent to
    <a href="mailto:info@optioway.com">info@optioway.com</a>.
  </p>
</LegalLayout>
